import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import Select from 'react-select';
import 'react-select/less/default.less';
import {callers} from '../reducers/users';

import UserAvatar from './UserAvatar';

@connect(state => ({
    users: state.users.users
}))
export default class StaffMemberPicker extends React.Component {
    static propTypes = {
        onSelectChange: PropTypes.func.isRequired,
        selectPlaceHolder: PropTypes.string.isRequired,
        onlyOneAssign: PropTypes.bool.isRequired,
        assignedUserIds: PropTypes.array.isRequired,
        includeAvatarPicker: PropTypes.bool.isRequired,
        callersOnly: PropTypes.bool.isRequired,
        blacklistUserIds: PropTypes.array
    };
    static defaultProps = {
        onlyOneAssign: false,
        assignedUserIds: [],
        selectPlaceHolder: "Select...",
        includeAvatarPicker: true,
        callersOnly: false,
        hideAuthUser: false,
        blacklistUserIds: []
    };
    constructor(props) {
        super(props);
        this.isAssigned = this.isAssigned.bind(this);
    }
    componentDidMount() {
        if(this.props.autofocus) {
            React.findDOMNode(this.refs.reactSelect).focus();
        }
    }
    handleSelectChange(selectedIds) {
        this.props.onSelectChange(selectedIds);
    }
    toggleAssignedStaffMember(userId) {
        var assignedUserIds = this.props.assignedUserIds.includes(userId) ?
            this.props.assignedUserIds.filter(id => id != userId) : this.props.assignedUserIds.concat([userId]);

        this.props.onSelectChange(
            assignedUserIds
        );
    }
    isAssigned(userId) {
        return this.props.assignedUserIds.includes(userId);
    }
    assignUser(userId) {
        this.props.onSelectChange([userId]);
    }
    render() {
        var sortPerCallerOrder = (users) => {
            if(! users.length) return [];
            var sortedArray = [];
            callers.forEach(email => {
                if(users.find(u => u.email == email))
                    sortedArray.push(users.find(u => u.email == email))
            });

            return sortedArray;
        };

        var filteredUsers = this.props.callersOnly ? sortPerCallerOrder(this.props.users.filter(user => callers.includes(user.email))) : this.props.users;

        var filteredUsers = filteredUsers.filter(user => ! this.props.blacklistUserIds.includes(user.id));
        
        var staffOptions = filteredUsers.map(u => {
            return ({label: `${u.firstName} ${u.lastName}`, value: u.id});
        });

        return (
            <div id="staff-picker" style={this.props.style}>
                <Select
                    ref="reactSelect"
                    placeholder={this.props.selectPlaceHolder}
                    multi={! this.props.onlyOneAssign}
                    name="form-field-name"
                    value={this.props.assignedUserIds}
                    options={staffOptions}
                    onChange={this.handleSelectChange.bind(this)} />
                    {this.props.includeAvatarPicker &&
                        <div className="flex-container wrap" style={{marginTop: '20px'}}>
                            {filteredUsers.map(u =>
                                <div key={u.id} className={this.isAssigned(u.id) ? "avatar-select-box selected": "avatar-select-box"}
                                    onClick={this.props.onlyOneAssign ? this.assignUser.bind(this, u.id) : this.toggleAssignedStaffMember.bind(this, u.id)}>
                                    <UserAvatar user={u} useLink={false} />
                                    <p>{u.firstName}</p>
                                </div>
                            )}
                        </div>
                    }
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./app/components/StaffMemberPicker.js